<mat-card>
	<mat-card-header>
		<mat-card-title>
			<b i18n>SUEROTERAPIA Y AUTOSANGUIS</b>
		</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<div class="share-buttons">
			<button mat-icon-button [matMenuTriggerFor]="shareMenu" i18n-aria-label="@@sueroterapia-autosanguis-share-aria-label|Accessible label of the share icon button" aria-label="Compartir" matTooltip="Compartir" i18n-matTooltip="@@sueroterapia-autosanguis-share-tooltip|Tooltip for the share icon button" (menuOpened)="loadShareWidgets()">
				<mat-icon>share</mat-icon>
			</button>
			<mat-menu #shareMenu="matMenu">
				<button mat-menu-item>
					<div class="fb-share-button" [attr.data-href]="shareUrl" [attr.data-layout]="'button_count'" [attr.data-size]="'large'">
						<a target="_blank" rel="noopener" [href]="shareFacebookUrl" class="fb-xfbml-parse-ignore" i18n="@@sueroterapia-autosanguis-facebook-share|Facebook share link inside the share menu">Compartir</a>
					</div>
				</button>
				<button mat-menu-item>
					<a [href]="shareXUrl" target="_blank" rel="noopener" class="twitter-share-button" [attr.data-size]="'large'" [attr.data-url]="shareUrl">Tweet</a>
				</button>
			</mat-menu>
		</div>
		<div class="content-container">
			<h4 i18n>
			Tratamiento consistente en la administración de sueros específicos
			que favorecen la autocuración del organismo a partir de una selección de vitaminas, oligoelementos,
			y medicamentos biorreguladores, biológicos naturales según las necesidades del paciente
			</h4>
			<div class="patient-img-container">
				<img class="patient-img" ngSrc="images/patient.png" i18n-alt alt="lyo medical" fill>
			</div>
		</div>
		<div class="content-container">
			<div class="content-container-row">
				<div class="content-item">
					<img class="content-item-img" ngSrc="images/endovenosa.png" i18n-alt alt="lyo medical" [width]="250" [height]="250">
					<h4 i18n>Aplicación endovenosa de sueros personalizados según las necesidades y objetivos específicos de cada persona</h4>
				</div>
				<div class="content-item">
					<img class="content-item-img" ngSrc="images/cardiograma.png" i18n-alt alt="lyo medical" [width]="250" [height]="250">
					<h4 i18n>Consulta con nosotros para más información y conocer cuál es el suero adecuado para ti</h4>
				</div>
				<div class="content-item">
					<img class="content-item-img" ngSrc="images/adn.png" i18n-alt alt="lyo medical" [width]="250" [height]="250">
					<h4 i18n>Medicamentos de origen natural, con registro INVIMA</h4>
				</div>
			</div>
		</div>
	</mat-card-content>
</mat-card>
